// /////////////////////////////////////////////////////////////////////////////////////
//                              Copyright (c) 2026
//                                    RXO Inc.
//                          All Rights Reserved Worldwide
//
// WARNING:  This program (or document) is unpublished, proprietary
// property of RXO Inc. and is to be maintained in strict confidence.
// Unauthorized reproduction, distribution or disclosure of this program
// (or document), or any program (or document) derived from it is
// prohibited by State and Federal law, and by local law outside of the U.S.
// /////////////////////////////////////////////////////////////////////////////////////

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import CloseBidModal from "../award-import/CloseBidModal";
import messages from "../../../helpers/messages";
import {
  closeBid,
  resetCloseBidActionState,
  fetchBidSummary,
  fetchBidMessages
} from "../../../slices/bidSummarySlice";
import { fetchBidDetails } from "../../../slices/bidDetailsSlice";

function SelfPricedEarlyCloseBidActions({
  summary,
  user,
  forceCrmCloseLostForm = false
}) {
  const dispatch = useDispatch();
  const route = useLocation().pathname.split("/")[3] || "";
  const { closeBidActionIsLoading, closeBidActionFailure } = useSelector(
    state => state.bidSummary
  );
  const [openCloseBidModal, setOpenCloseBidModal] = useState(false);
  const { bidId } = summary;
  const { role } = user;

  const handleCloseBidClick = crmPayload => {
    dispatch(closeBid(bidId, role, route, crmPayload));
  };

  const handleClose = fetchDetails => {
    if (fetchDetails) {
      dispatch(resetCloseBidActionState());
      dispatch(fetchBidSummary({ bidId, role }));
      route === "summary" && dispatch(fetchBidMessages(bidId));
      route === "details" && dispatch(fetchBidDetails(bidId));
    }
    setOpenCloseBidModal(false);
  };

  return (
    <>
      <button
        className="text-button univers-67-bold-cond font-size-14 uppercase mx-8 h-32 short-button px-12"
        data-testid="self-priced-early-close-bid"
        type="button"
        onClick={() => setOpenCloseBidModal(true)}
      >
        {messages.closeBid.defaultMessage}
      </button>
      {openCloseBidModal && (
        <CloseBidModal
          handleClose={handleClose}
          handleCloseBidClick={handleCloseBidClick}
          isLoading={closeBidActionIsLoading}
          isFailure={closeBidActionFailure}
          summary={summary}
          forceCrmCloseLostForm={forceCrmCloseLostForm}
        />
      )}
    </>
  );
}

export default SelfPricedEarlyCloseBidActions;
